import React from 'react';
import Modal from './Modal';
import { useSelector } from 'react-redux';
const VendorModal = ({ visible = false, onClose = () => {} }) => {
    const session = useSelector((state) => state.session);
    const [vendor, setVendor] = React.useState(session?.selectedVendor || session?.user?.vendors[0]?.id);
    React.useEffect(() => {
        setVendor(session?.selectedVendor || session?.user?.vendors[0]?.id);
    }, [session.selectedVendor, session.user.vendors]);
    const handleClose = () => {
        let _vendor = session?.user?.vendors.find((v) => v.id === Number(vendor));
        onClose(_vendor);
    };
    return (
        <Modal
            visible={visible}
            label="Select Vendor"
            onClose={onClose}
            innerClassName="modal-s text-center"
            showClose={false}
            center
        >
            <div>
                <h2>Select Vendor Account</h2>
                <div className="mb-3">
                    <small>
                        This will impact the catalog and financial information you can see. You can change the vendor
                        account you are accessing by choosing Account, then Change Account, in the sidebar menu.
                    </small>
                </div>
                <div className="mb-3">
                    <select className="form-control" onChange={(e) => setVendor(e.target.value)} value={vendor}>
                        {session?.user?.vendors?.map((vendor) => (
                            <option key={vendor.id} value={vendor.id}>
                                {vendor.vendorname || 'Vendor Name Missing'}
                            </option>
                        ))}
                    </select>
                </div>
                <button className="btn btn-sm btn-primary" onClick={handleClose}>
                    Continue
                </button>
            </div>
        </Modal>
    );
};
export default VendorModal;
